<template>
  <div>
    <v-card tile elevation="0" class="item-card">
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
      <ValidationObserver ref="observer">
        <v-container fluid>
          <v-row>
            <v-col
              cols="12"
              class="text-white bk-dark-gray font-bold pa-2 mb-4"
            >
              基本設定タブにて「外部媒体の求人ページ」を設定した場合、ここより下の設定は不要です。
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pb-0">
              <h3>求人用バナー</h3>
              <div class="mt-2 mb-2">
                <div>求人ページの先頭に表示するバナーを設定します。</div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="pt-0">
              <ValidationProvider
                v-slot="{ errors, valid }"
                name="求人バナーのリンク先URL"
                rules="url|max:255"
              >
                <v-text-field
                  v-model="category_items.job_banner1.name"
                  :name="category_items.job_banner1.category_code + '_url'"
                  label="求人バナーのリンク先URL"
                  :error-messages="errors"
                  :success="valid"
                  outlined
                  placeholder="https://..."
                  hint="任意入力です。リンク先の正確なURLを入力してください。リンク先は新しいタブで開きます。"
                  persistent-hint
                  class="mb-2"
                ></v-text-field>
              </ValidationProvider>
              <image-uploader-component
                :ref="category_items.job_banner1.ref"
                :width="category_items.job_banner1.width"
                :height="category_items.job_banner1.height"
                :image_path="category_items.job_banner1.detail"
                :contain="true"
              ></image-uploader-component>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>求人情報の詳細</h3>
              <div class="mt-2 mb-2">
                <div>「職種」が未入力の時、求人詳細は表示されません。</div>
              </div>
            </v-col>
          </v-row>
          <div v-for="(item, index) in category_items" :key="index">
            <v-row>
              <v-col v-if="item.type == 'text'" cols="12" sm="4">
                <v-text-field
                  v-model="item.detail"
                  :name="item.category_code"
                  :label="item.name"
                  :success="true"
                  :placeholder="item.placeholder"
                  outlined
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col v-else-if="item.type == 'textarea'" cols="12">
                <v-textarea
                  v-model="item.detail"
                  :name="item.category_code"
                  :label="item.name"
                  :success="true"
                  :placeholder="item.placeholder"
                  outlined
                  hide-details
                  :rows="item.rows || 3"
                  auto-grow
                ></v-textarea>
              </v-col>
              <v-col v-else-if="item.type == 'html'" cols="12">
                <h3>備考</h3>
                <div class="mt-2 mb-2">
                  <v-btn
                    text
                    color="primary"
                    class="font-weight-bold pa-1 d-inline"
                    @click="onHtmlClear"
                    >HTMLをクリア</v-btn
                  >
                  <p class="mini text-red">
                    ※GoogleMapやバナー等のHTMLを使用する際は「ソース」をクリックしてから、HTMLを貼り付け、再度「ソース」をクリックして元の画面に戻ってから保存してください。
                  </p>
                </div>
                <v-card tile elevation="0" class="mb-6">
                  <div class="ma-3">
                    <ckeditor-component
                      :ref="item.ref"
                      :data="item.detail"
                    ></ckeditor-component>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-divider v-show="item.sort <= 10" class="mt-4 mb-4"></v-divider>
          </div>
        </v-container>
      </ValidationObserver>
      <v-container fluid>
        <v-row justify="start">
          <v-col cols="6" sm="3">
            <general-button btn_type="info" btn_block @click-event="onSubmit"
              ><template v-slot:icon
                ><v-icon left>mdi-content-save</v-icon></template
              >保存</general-button
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import {
  ref,
  set,
  reactive,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import store from "@/store/index.js";
import { repositoryFactory } from "@/repository/repositoryFactory";
import setting from "@/common/setting.js";
import imageUploaderComponent from "./imageUploader.vue";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  components: {
    imageUploaderComponent,
  },
  props: ["shop_site_id"],
  setup(props, ctx) {
    const HpListDetailRepository = repositoryFactory.get("hpListDetails");
    const refCkeditorJobHtml = ref(null);
    const refIUBanner1 = ref(null);

    const data_id = 6; // 求人情報 6固定
    const state = reactive({
      // 入力項目カテゴリごとのデータ構造体
      category_items: {
        job_banner1: {
          type: "link_image",
          ref: "refIUBanner1",
          category_num: 0, // 0固定
          category_code: "job_banner1",
          name: "",
          detail: "",
          component: imageUploaderComponent,
          width: 600,
          height: 300,
          sort: 1,
        },
        job_title: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "job_title",
          name: "職種",
          detail: "",
          sort: 2,
          placeholder: "例) セラピスト、エステティシャン",
          rows: 3,
        },
        job_description: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "job_description",
          name: "仕事内容",
          detail: "",
          sort: 3,
          placeholder: "例) リラクゼーションサロンでの施術業務全般",
          rows: 6,
        },
        qualification: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "qualification",
          name: "資格",
          detail: "",
          sort: 4,
          placeholder: "例) 年齢◯◯〜◯◯、未経験者歓迎、経験者優遇",
          rows: 6,
        },
        salary: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "salary",
          name: "給与",
          detail: "",
          sort: 5,
          placeholder: "例) 月給◯◯万円〜、日給◯◯円〜、交通費支給",
          rows: 6,
        },
        job_hours: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "job_hours",
          name: "勤務時間",
          detail: "",
          sort: 6,
          placeholder: "例) 12:00〜翌3:00、週2日〜OK",
          rows: 6,
        },
        treatment: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "treatment",
          name: "待遇",
          detail: "",
          sort: 7,
          placeholder: "例) 研修制度あり、制服貸与、各種備品支給",
          rows: 6,
        },
        work_location: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "work_location",
          name: "勤務地",
          detail: "",
          sort: 8,
          placeholder: "例) 新宿区、渋谷区",
          rows: 6,
        },
        contact: {
          type: "textarea",
          ref: "",
          category_num: 0, // 0固定
          category_code: "contact",
          name: "連絡先・応募方法",
          detail: "",
          sort: 9,
          placeholder:
            "例) TEL:03-xxxx-xxxx、MAIL:xxxx@xxxx.com、担当:山田、メール応募可、オンラインで面接できます",
          rows: 6,
        },
        job_html: {
          type: "html",
          ref: "refCkeditorJobHtml",
          category_num: 0, // 0固定
          category_code: "job_html",
          name: "備考",
          detail: "",
          sort: 10,
        },
      },
    });

    const getListData = async () => {
      // サイト設定データ取得
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      const params = {
        shop_site_id: props.shop_site_id,
        data_id: data_id,
      };
      const response = await retryRequest(
        HpListDetailRepository.list_data,
        params,
        true
      );
      if (response.data) {
        if (response.data.length === 0) {
          // データがない場合は何もしない
        } else {
          // 取得したデータをstateにセット
          for (const key of Object.keys(state.category_items)) {
            const item = state.category_items[key];
            const getItem = response.data.find(
              (i) => i.category_code === item.category_code
            );
            if (!getItem) continue; // 該当データがない場合はスキップ

            item.name = getItem.name || "";
            item.detail = getItem.detail || "";
          }
        }
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");
    };

    onMounted(() => {
      getListData();
    });

    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();

      if (!isValid) {
        // エラー処理
        const el = document.querySelectorAll(
          ".v-text-field.error--text, .v-textarea.error--text"
        );
        if (el.length > 0) {
          el[0].scrollIntoView();
          window.scrollBy(0, -80);
        }
        return;
      } else {
        // サイト設定保存処理
        if (!window.confirm("保存してよろしいですか？")) {
          return false;
        }

        store.dispatch("loadingIcon/showIcon"); // ローディング表示

        for (const key of Object.keys(state.category_items)) {
          const item = state.category_items[key];
          if (item.type === "link_image") {
            // 画像アップロード処理
            const path = await ctx.refs[item.ref].saveImage();
            item.detail = path; // アップロード後の画像パスをセット
          } else if (item.type === "html") {
            // HTML入力処理
            item.detail = ctx.refs[item.ref][0].editorData;
          } else {
            // 特に何もしない
          }
        }

        const save_list = Object.values(state.category_items).map((item) => {
          return {
            shop_site_id: props.shop_site_id,
            data_id: data_id,
            category_num: 0,
            category_code: item.category_code,
            name: item.name,
            detail: item.detail,
            sort: item.sort,
          };
        });
        const params = {
          shop_site_id: props.shop_site_id,
          data_id: data_id,
          save_list: save_list,
        };
        await HpListDetailRepository.save_list(params)
          .then((response) => {
            if (response.data) {
              // 保存OK
              alert("求人情報を保存しました。");
            }
          })
          .catch((error) => {
            throw "ERROR:HpListDetailRepository.save_list (" + error + ")";
          });

        // ローディング非表示
        store.dispatch("loadingIcon/hideIcon");
      }
    };

    const onHtmlClear = () => {
      if (
        !window.confirm("HTMLに入力された内容をクリアします。よろしいですか？")
      ) {
        return;
      }
      state.category_items.job_html.detail = "";
      ctx.refs[state.category_items.job_html.ref][0].editorData = ""; // CKEditorの内容もクリア
    };

    // 返却オブジェクト定義
    return {
      setting,
      refCkeditorJobHtml,
      refIUBanner1,
      ...toRefs(state),
      onSubmit,
      onHtmlClear,
    };
  },
});
</script>
